// extracted by mini-css-extract-plugin
export default {"snackbar":"style_snackbar__7T08P","action":"style_action__pvqbH","error":"style_error__BVwtk","success":"style_success__XPGtK","warning":"style_warning__qhyf4"};